import React from "react";
import ReactModal from "react-modal";
import { axiospost, axiosput } from "../../helpers/httprequest";
import swal from "../../helpers/swal";
import { Form, Formik } from "formik";
import { ms_delete } from "@v2/validators";
import { useQueryClient } from "@tanstack/react-query";
import ErrorMessage from "../../components/ErrorMessage";

const BtnDeleteOLevel = ({ modules }) => {
  const [showmodal, setshowmodal] = React.useState(false);
  const queryClient = useQueryClient(); // Access the Query Client

  const _save = async (values) => {
    try {
      let req;
      if (modules === undefined) {
        req = await axiospost("ms_applicant_result", values);
      } else {
        req = await axiosput(`ms_applicant_result/${modules?._id}`, values);
      }
      if (req.status !== 200) {
        throw new Error("Sorry, system could not finish processing your request");
      }
      const { data: result } = req;
      if (result && result.type === "success") {
        const { message, type } = result;
        swal(type, message);
        queryClient.invalidateQueries({ queryKey: ["oLevelResult"] });
      } else {
        throw new Error(result.message);
      }
    } catch ({ message }) {
      swal("warning", message);
    }
  };

  const _show = () => {
    setshowmodal(true);
  };

  return (
    <div>
      <ReactModal isOpen={showmodal} onRequestClose={() => setshowmodal(false)} className="ReactModal">
        <div className="modal-dialog " role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title text-center">Delete Student O-Level Result</h5>
              <span className="text-danger pointer" onClick={() => setshowmodal(false)}>
                x
              </span>
            </div>
            <div className="modal-body">
              <Formik
                initialValues={{
                  delete: "",
                }}
                validationSchema={ms_delete.deleteValidator}
                initialTouched={{ zip: true }}
                onSubmit={_save}
              >
                {({ isSubmitting, touched, errors }) => (
                  <Form>
                    <div className="row">
                      <div className="col-md-12 ">
                        <ErrorMessage
                          name={"delete"}
                          label="Type the word delete"
                          type="text"
                          key={`error_delete`}
                          errors={errors?.delete}
                          touched={touched?.delete}
                        />
                      </div>

                      <div className="col-md-12 text-right">
                        <button disabled={isSubmitting} type="submit" className="btn btn-lg btn-block btn-danger ml-1">
                          {isSubmitting ? `Please wait...` : `Delete`}
                        </button>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </ReactModal>
      <div>
        <button className="btn btn-icon btn-danger btn-rounded" onClick={_show}>
          <i className="ti-trash"></i>
        </button>
      </div>
    </div>
  );
};

export default BtnDeleteOLevel;
